import { createSelector } from 'reselect'

export const getCategories = createSelector(
  (state) => state && state.categories && state.categories.elements && Array.isArray(state.categories.elements)
    ? state.categories.elements
    : [],
  (categories) => categories
)
